<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <!--<span style="color: #FFFFFF">找人才</span>-->
      </p>
    </header>
    <div style="margin-top: 65px;padding-bottom: 60px">
      <div style="background-color:#6e9bcf">
      <div class="leaderDiv"  >
        <!--<h3>职位Leader</h3>-->
        <div class="Leader">
          <div class="LeaderMessage">
            <p class="personalTopNmae">{{list.name}}</p>
            <p class="leaderFont" style="color: #505050eb" v-if="list.workexperience[0]">
              <span class="leaderFontSpan">{{list.workexperience[0].name}}</span>
            </p>
            <!--<p><span class="leaderFontSpan" >{{ index.workexperience[0].positionname}}</span></p>-->
            <p  class="LeaderSpan" style="color: #c1c0c0">
              <span >{{list.residence}}</span>
              <span >{{list.workage}}年</span>
              <span  v-if="list.education==1">初中</span>
              <span  v-else-if="list.education==2">高中</span>
              <span  v-else-if="list.education==3">中专</span>
              <span  v-else-if="list.education==4">大专</span>
              <span  v-else-if="list.education==5">本科</span>
              <span  v-else-if="list.education==6">硕士</span>
              <span  v-else-if="list.education==7">博士</span>
              <span  >15K-20K</span>
              <span  v-if="list.expectsalary==1">1K-2K</span>
              <span  v-else-if="list.expectsalary==2">2K-4K</span>
              <span v-else-if="list.expectsalary==3">4K-6K</span>
              <span v-else-if="list.expectsalary==4">6K-8K</span>
              <span v-else-if="list.expectsalary==5">8K-10K</span>
              <span v-else-if="list.expectsalary==6">10K-15K</span>
              <span v-else-if="list.expectsalary==7">20K-25K</span>
              <span v-else-if="list.expectsalary==8">20K-25K</span>
              <span v-else-if="list.expectsalary==9">25K-35K</span>
              <span v-else-if="list.expectsalary==10">35K-50KK</span>
              <span v-else-if="list.expectsalary==11">50K-70K</span>
              <span v-else-if="list.expectsalary==12">70K-100K</span>
              <span v-else-if="list.expectsalary==13">100K以上</span>
            </p>

            <!--<p class="leaderFont" style="color: #505050eb" v-if="list.school?list.school[0]:{}">{{list.school[0].name}}·{{index.list[0].major}}</p>-->
            <!--<span class="leaderFontY" style="color: #505050eb">移动互联网</span>-->
            <!--<p class="introduction" style="color: #505050eb">{{index.introduction}}</p>-->
            <span class="laader" style="font-size: 12px"></span>
          </div>
          <div class="comPosition" >
            <img  src="@/assets/img/tx.jpg" alt="">
          </div>
        </div>
      </div>
        <!--//求职意向-->

      </div>
       <div >
        <div class="jobStatusDiv">
          <h4>求职意向</h4>
          <p class="jobStatus" v-if="job"> <span>{{job.expectposition}}·{{job.workcity}}</span><span style="color: #3CB371">{{qwxz}}</span></p>
          <p v-else >请填写求职意向</p>
          <p v-if="status">{{status}}</p>
        </div>
         <div class="jobStatusDiv">
           <h4>我的优势</h4>
           <!--<p class="jobStatus" v-if="job"> <span>{{job.expectposition}}·{{job.workcity}}</span><span style="color: #3CB371">{{qwxz}}</span></p>-->
           <!--<p v-else >请填写求职意向</p>-->
           <p v-if="list">{{list.introduction}}</p>
         </div>
         <div class="jobStatusDiv">
           <h4>工作经历</h4>
           <div v-if="list" v-for="(index,key) in list.workexperience" @click="getDescribe(index.id)">
             <!--<router-link  :to="{name:'editWork',params:{id:index.id}}">-->
             <!--{{index.id}}-->
             <p><span>{{index.name}}</span><span></span></p>
             <p>{{index.department+` · `}}{{index.positionname}}</p>
             <p>{{index.entrytime+'--'+index.resigntime}}</p>
             <p>工作内容：</p>
             <p>{{index.workdescription}}</p>
             <!--</router-link>-->
           </div>
           <!--<p class="jobStatus" v-if="job"> <span>{{job.expectposition}}·{{job.workcity}}</span><span style="color: #3CB371">{{qwxz}}</span></p>-->
           <!--<p v-else >请填写求职意向</p>-->
         </div>
         <div class="jobStatusDiv">
           <h4>项目经历</h4>
           <div style="padding-top: 10px" v-if="list" v-for="(index,key) in list.projectexperience">
             <h4 style="padding-top: 10px">{{index.proname}}</h4>
             <p>{{index.starttime+"--"+index.endtime}}</p>
             <p>项目描述：</p>
             <p>{{index.prodescription}}</p>
             <p>成就：</p>
             <p>{{index.dutydescription}}</p>
             <p>项目链接：</p>
              <p>{{index.projecturl}}</p>
           </div>
         </div>
         <div class="jobStatusDiv">
           <h4>教育经历</h4>
           <div v-if="list" v-for="(index,key) in list.school">
               <h5 style="padding-top: 10px">{{index.name}}</h5>
               <p>{{index.major}}</p>
               <p>{{index.schoolstart+"--"+index.schoolstart}}</p>

           </div>
         </div>
      </div>

    <!--<van-tabbar route v-model="active">-->
      <!--<van-tabbar-item replace to="/comTalents" icon="wap-home-o">-->
        <!--招人才-->
      <!--</van-tabbar-item>-->
      <!--<van-tabbar-item replace to="/comMessage" icon="envelop-o">-->
        <!--消息-->
      <!--</van-tabbar-item>-->
      <!--<van-tabbar-item replace to="/comPosition" icon="desktop-o">-->
        <!--职位-->
      <!--</van-tabbar-item>-->
      <!--<van-tabbar-item replace to="/comMy" icon="contact">-->
        <!--我的-->
      <!--</van-tabbar-item>-->
    <!--</van-tabbar>-->
    </div>
    <div class="bottom">
      <!--<router-link to="/remPosition">-->
      <p class="" @click="toRemPosition(list.id)">下简历</p>
      <!--</router-link>-->
      <p class="" @click="saveJobStater()">邀请投递</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:true,
        activeName: 'a',
        active:0,
        list:{
          workexperience:"",
          expectsalary:""
        },
        loading: false,
        finished: false,
        isDownLoading:false, //下拉刷新
        refreshing: false,
        index:1,
        job:{},
        qwxz:"",
      }
    },
    mounted(){
      this.obtainMyer()
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      saveJobStater(){
        this.$router.push({
          path:"/invitationPost",
          query:{
            id:this.$route.query.id
          }
        })
      },

      obtainMyer(){
        console.log(this.$route.query.id)
        this.$api.talentsDtails({
          userid:this.$route.query.id
        })
          .then(res=>{

            this.list=res.data?res.data[0]:{}
            console.log(this.list)
            this.job=res.data[0].jobintention ?res.data[0].jobintention[0]:{}
            const jobintention=res.data[0]['jobintention'][0]? res.data[0]['jobintention'][0]['expectsalary']:""
            switch (jobintention){
              case 1:
                this.qwxz = '1K-2K';
                break;
              case 2:
                this.qwxz = '2K-4K';
                break;
              case 3:
                this.qwxz = '4K-6K';
                break;
              case 4:
                this.qwxz = '6K-8K';
                break;
              case 5:
                this.qwxz = '8K-10K';
                break;
              case 6:
                this.qwxz = '10K-15K';
                break;
              case 7:
                this.qwxz = '15K-20K';
                break;
              case 8:
                this.qwxz = '20K-25K';
                break;
              case 9:
                this.qwxz = '25K-35K';
                break;
              case 10:
                this.qwxz = '35K-50K';
                break;
              case 11:
                this.qwxz = '50K-70K';
                break;
              case 12:
                this.qwxz = '70K-100K';
                break;
              case 13:
                this.qwxz = '100K以上';
                break;
              default:
                this.qwxz = '';
                break;
            }
            switch (res.data[0].jobstatus){
              case 1:
                this.status='离职随时到岗';
              case 2:
                this.status='在职月内到岗';
              case 3:
                this.status='在职考虑机会';
              case 4:
                this.status='在职暂不考虑';
              default:
                this.status='离职随时到岗';
            }
          })
      },




    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    padding: 0;
    margin: 0;
  }
  .headerSpan{
    margin-left: 1rem;
    line-height: 10px;
    color: #FFFFFF;
  }
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
    z-index: 100;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .Leader{
    padding: 10px 1rem;
    margin: 0;
    display: flex;
    justify-content: space-between;
    border-bottom: solid 7px #EAEAEA;
    background: #FFFFFF;
    border-radius: 20px 20px 0 0 ;
  }
  .LeaderMessage p{
    padding-top: 6px;
    /*font-size: 12px;*/
  }
  .leaderFont{
    font-size: 14px;
    display: flex;
    /*max-width: 19px;*/
  }
  .comPosition img{
    width: 60px;
    height: 60px;
    border-radius: 100%;
  }
  .personalTopNmae{
    font-weight: 800;
  }
  .leaderFont span{
    display: inline-block;
  }
  .leaderFontSpan{
    font-size: 14px;
  }
  /*.leaderFont{*/
  /*font-size: 14px;*/
  /*}*/
  .leaderFontY{
    background: #7fb3db;
    padding: 4px;
    border-radius: 6px;
    font-size: 12px;
    margin: 7px 0;
    display: inline-block;
  }
  .leaderDiv:first-child{
    background: #6e9bcf;
  }
  .LeaderSpan span{
    font-size: 14px;
  }
  .introduction{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 10rem;
    font-size: 14px;
  }
  .jobStatus{
    display: flex;
    justify-content: space-between;
  }
  .jobStatusDiv{
    padding: 10px 1rem;
    border-bottom: solid 1px #EAEAEA;
  }
  .jobStatusDiv p{
    font-size: 13px;
    padding-top: 8px;
  }
  .bottom{
    display: flex;
    justify-content: space-around;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 100;
    background: #ffffff; /*底部覆盖不住字*/
  }
  .bottom p{
    width: 50%;
    background: #6e9bcf;
    color: #FFFFFF;
    text-align: center;
    padding: 10px 0px;
  }
  /*.LeaderMessage */
</style>



// WEBPACK FOOTER //
// src/components/company/comTalentsDtails.vue